import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  basename: '/dashboard',
});

export default history;
